import HOCWatchValue from 'components/common/hoc-watch-value';
import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import * as React from 'react';

import ActivitySaleGuestDetailTable from './item-table';

interface Props {
  parentIndex: number;
}

export default function ActivitySaleItem(props: Props) {
  const _values = HOCWatchValue({
    keys: [`approvalable.activitySales.${props.parentIndex}`],
  });
  const { isGroupedPrice, activitySaleGuests } =
    _values[`approvalable.activitySales.${props.parentIndex}`];

  if (!activitySaleGuests?.length) {
    return <></>;
  }

  if (isGroupedPrice) {
    return (
      <ActivitySaleGuestDetailTable
        parentIndex={props.parentIndex}
        guestIndex={0}
      />
    );
  }

  return (
    <>
      {activitySaleGuests.map((field, idx) => (
        <React.Fragment key={field.id}>
          <Separator gap={16} />
          <Text variant="ParagraphSmall">{field.guestName || '-'}</Text>
          <Separator gap={16} />
          <ActivitySaleGuestDetailTable
            parentIndex={props.parentIndex}
            guestIndex={idx}
          />
        </React.Fragment>
      ))}
    </>
  );
}
